import { render, staticRenderFns } from "./DeleteArticleInMovement.vue?vue&type=template&id=af1194ce&scoped=true"
import script from "./DeleteArticleInMovement.vue?vue&type=script&lang=js"
export * from "./DeleteArticleInMovement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af1194ce",
  null
  
)

export default component.exports